import { useMutation } from '@apollo/client'
import { BULK_DELETE_MEMBERS } from './operation'

type useDeleteMembersProps = {
  onCompleted: () => void
}
export const useDeleteMembers = ({ onCompleted }: useDeleteMembersProps) =>
  useMutation(BULK_DELETE_MEMBERS, {
    onCompleted,
  })
